<template>
  <div class="panel granary-right-panel">
    <div class="content">
      <div class="list-item" v-for="(item, index) in yyList" :key="index">
        <div class="img-box">
          <img :src="item.icon" alt="" />
        </div>
        <div class="name"><i class="point"></i>{{ item.name }}</div>
        <div class="total-box">
          <span class="num">{{ item.num }}</span
          >（ <span class="unit">{{ item.unit }}</span
          >）
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getTop10 } from "@/api/pzsd";
export default {
  data() {
    return {
      yyList: [
        {
          name: "养殖渔船",
          num: 268,
          unit: "艘",
          icon: require("@/assets/images/granary/yy/yzyc.png")
        },
        {
          name: "捕捞渔船",
          num: 342,
          unit: "艘",
          icon: require("@/assets/images/granary/yy/blyc.png")
        },
        {
          name: "捕捞辅助渔船",
          num: 157,
          unit: "艘",
          icon: require("@/assets/images/granary/yy/lc.png")
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .content
    height 100%
    display flex
    justify-content space-around
    align-items flex-end
    .list-item
      width 100px
      .img-box
        display flex
        align-items center
        justify-content center
        height 140px
        background url('~images/granary/yy/cb-bg.png') no-repeat
        background-size 100% 100%

      .name
        margin-top 4px
        font-size 14px
        text-align center
        .point
          display inline-block
          width 6px
          height 6px
          margin-right 4px
          border-radius 50%
          background-color #00ffff
      .total-box
        text-align center
        color #00ffff
        .num
          font-size 24px
</style>
